import { Component, OnInit, HostBinding, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IElementHis } from '../../services/eleview/types/model';

@Component({
	selector: 'common-show-history-dialog',
	templateUrl: './show-history-dialog.component.html',
	styleUrls: ['./show-history-dialog.component.scss']
})
export class ShowHistoryDialogComponent implements OnInit {
	@HostBinding('class.show-history-dialog') hostClass = true;
	constructor(
		public dialogRef: MatDialogRef<ShowHistoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IElementHis[]
	) {}

	ngOnInit() {}
	close() {
		this.dialogRef.close();
	}
}
